<template>
  <div class="cp-home">
    <!-- <ShadowDivider class="cp-home-shadow-divider" /> -->
    <b-carousel
      icon-pack="fas"
      icon-size="is-large"
      :arrow="false"
      :arrow-hover="false"
      :autoplay="true"
      >
      <b-carousel-item
        v-for="(carousel, i) in carousels"
        :key="i"
      >
        <span class="cursor" @click="goToProductDetail(carousel.id)">
          <img :src="carousel.url" />
        </span>
      </b-carousel-item>
    </b-carousel>
    <section class="section-one">
          <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-58_JrbtBLLmy.png"
               class="section-one-bg is-hidden-touch"
          >
           <img src="https://ik.imagekit.io/osusf6xvdf/beta/Madam_Ranee_Mobile_site_Export-10_lbr59xLUiCc.png"
               class="section-one-bg is-hidden-desktop"
          >
        <div class="columns container ">
          <div class="column is-four-fifths">
          </div>
          <div class="column text-center">
            <h2></h2>
          </div>
        </div>
        <img src="../../assets/img/product/product-leave-1.png"
        class="section-one-leave is-hidden-touch">
    </section>
    <section class="section-two">
      <XContainer class="cp-home-product-section">
        <img src="../../assets/img/product/product-section-two-bg.png"
        class="section-two-bg is-hidden-touch">
        <!-- <div
          :class="[
            'cp-home-product-section-label',
            'has-background-primary',
            'has-text-white-bis',
            'has-text-centered',
            'is-3',
            'title',
            'is-size-4-mobile',
          ]"
        > -->
        <div class="md-text-title">
          PRODUCTS
        </div>
        <!-- <b-carousel-list
            :data="products"
            :items-to-show="2"
            class="has-text-centered is-hidden-desktop"
            :autoplay="true"
        >
            <template slot="item" slot-scope="list">
               <Product
                  :image="list.list.product_image.length ? list.list.product_image[0] : ''"
                  :title="list.list.product_name"
                  :detail="list.list.product_information"
                  :sale="list.list.is_discount === 'yes'"
                  :price="list.list.price"
                  :discount="list.list.discount"
                  @click="goToProductDetail(list.id)"
                />
            </template>
        </b-carousel-list> -->
        <div class="cp-home-product-section-list has-text-centered">
          <div class="columns is-desktop is-12-mobile">
            <ProductHome
              class="column is-12-mobile is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-49_m7W8vx70T1.png'
              title='Madam Ranee Lemon Herbal Soap (ExWh)'
              :sale="products[0].is_discount === 'yes'"
              :price="products[0].price"
              :discount="products[0].discount"
              @click="goToProductDetail(24)"
              />
             <ProductHome
              class="column is-12-mobile is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-51_A5etP8jqJC.png'
              title="Madam Ranee Tamarind Soap"
              :sale="products[1].is_discount === 'yes'"
              :price="products[1].price"
              :discount="products[1].discount"
              @click="goToProductDetail(9)"
              />
               <ProductHome
              class="column is-3-desktop is-12-mobile"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-48_2y5_DTpcz.png'
              title="Madam Ranee Lavender Herbal Soap (Nano)"
              :sale="products[2].is_discount === 'yes'"
              :price="products[2].price"
              :discount="products[2].discount"
              @click="goToProductDetail(38)"
              />
               <ProductHome
              class="column is-3-desktop is-12-mobile"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-47_s7Wvo8nhK9Ou.png'
              title='Madam Ranee Rice Milk Herbal Soap (Nano)'
              :sale="products[3].is_discount === 'yes'"
              :price="products[3].price"
              :discount="products[3].discount"
              @click="goToProductDetail(37)"
              />
          </div>
           <!-- <div class="columns is-desktop is-mobile is-hidden-touch">
               <ProductHome
              class="column is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-50_Y5MaFcNrj4b5.png'
              :title="products[4].product_name_localized"
              :detail="products[4].product_information"
              :sale="products[4].is_discount === 'yes'"
              :price="products[4].price"
              :discount="products[4].discount"
              @click="goToProductDetail(products[4].id)"
              />
               <ProductHome
              class="column is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-52_YVVBLIs6PLnC.png'
              :title="products[5].product_name_localized"
              :detail="products[5].product_information"
              :sale="products[5].is_discount === 'yes'"
              :price="products[5].price"
              :discount="products[5].discount"
              @click="goToProductDetail(products[5].id)"
              />
               <ProductHome
              class="column is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-46_myO7ShGy1O.png'
              :title="products[6].product_name_localized"
              :detail="products[6].product_information"
              :sale="products[6].is_discount === 'yes'"
              :price="products[6].price"
              :discount="products[6].discount"
              @click="goToProductDetail(products[6].id)"
              />
               <ProductHome
              class="column is-3-desktop"
              image='https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-45_0Lx5OKf16Yw.png'
              :title="products[7].product_name_localized"
              :detail="products[7].product_information"
              :sale="products[7].is_discount === 'yes'"
              :price="products[7].price"
              :discount="products[7].discount"
              @click="goToProductDetail(products[7].id)"
              />
          </div> -->
        </div>
      </XContainer>
    </section>
    <section class="section-three is-12-mobile">
      <div class="home-section-bg-2">
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-12_DfLReEOq7OuM.jpg"
        class="is-hidden-touch">
        <div class="is-hidden-desktop">
          <img src="https://ik.imagekit.io/osusf6xvdf/beta/Madam_Ranee_Mobile_site_Export-11_Vji02LmWF.png"
            class=""
          >
          <!-- <div class="section-three-content has-text-centered">
            <div class="section-three-content-logo">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/logo-primary_08zybS5ONeu.png"
              width="100">
            </div>
            <div class="section-three-content-content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            </div>
            <div class="section-three-content-button">
               <b-button
                 class="md-button-bg">
                  More </b-button>
            </div>
          </div> -->
        </div>
      </div>
    </section>
     <section class="section section-four is-desktop is-mobile container is-hidden-touch
     is-hidden-desktop">
       <div class="section-four-title">
          Blog
       </div>
       <div class="columns">
          <div class="column is-12-mobile is-6-desktop">
            <ArticleBorderless
                class="cp-article-list-view-vertical-article is-hidden-touch"
                :title="articles[0].title_localized"
                :excerpt="articles[0].prefix_localized"
                :image="articles[0].cover_image"
                :type="true"
                @click="gotoArticlePage(articles[0].id)"
              />
            <!-- <Article
                v-for="(article, index) in articles"
                :key="index"
                class="cp-article-list-view-vertical-article"
                :title="article.title_localized"
                :excerpt="article.prefix_localized"
                :image="article.cover_image"
                @click="gotoArticlePage(article.id)"
              /> -->
          </div>
            <div class="column is-12-mobile is-6-desktop">
               <ArticleBorderless
                class="cp-article-list-view-vertical-article
                cp-article-list-view-vertical-articel-minimize
                is-hidden-touch"
                :title="articles[1].title_localized"
                :excerpt="articles[1].prefix_localized"
                :image="articles[1].cover_image"
                @click="gotoArticlePage(articles[1].id)"
              />
              <br>
              <div class="columns">
                <div class="column is-12-mobile ">
                   <ArticleBorderless
                      class="cp-article-list-view-vertical-article "
                      :title="articles[2].title_localized"
                      :excerpt="articles[2].prefix_localized"
                      :image="articles[2].cover_image"
                      @click="gotoArticlePage(articles[2].id)"
                    />
                </div>
                <div class="column is-12-mobile">
                   <ArticleBorderless
                      class="cp-article-list-view-vertical-article"
                      :title="articles[3].title_localized"
                      :excerpt="articles[3].prefix_localized"
                      :image="articles[3].cover_image"
                      @click="gotoArticlePage(articles[3].id)"
                    />
                </div>
              </div>
            </div>
       </div>
      <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-3-bg_6nsNLBXbSq_.png"
      class="section-four-bg "> -->
    </section>
    <!-- <ShadowDivider /> -->
    <!-- <StandardSection /> -->
    <!-- <ShadowDivider :upside="true" /> -->
    <section class="section-five is-12-mobile">
      <StandardProductSection />
    </section>
    <OrderFloatIcon />

    <!-- <section class="section-six">
      <div class="section-six-test">
        aaa
      </div>
    </section> -->
    <!-- <SmallSellerSection /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import XContainer from '@/components/XContainer.vue';
// import Product from '@/components/Product.vue';
// import Article from '@/components/Article.vue';
import ArticleBorderless from '@/components/ArticleBorderless.vue';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';
import ProductHome from '@/components/ProductHome.vue';
// import IconSet from '@/components/IconSet.vue';
// import ShadowDivider from '@/components/ShadowDivider.vue';
// import SmallSellerSection from '@/components/SmallSellerSection.vue';
// import StandardSection from '@/components/StandardSection.vue';
// import Reader from '@/components/Quill/Reader.vue';
import StandardProductSection from '@/components/StandardProductSection.vue';
import { getFeaturedProducts } from '@/apis/product';
import { getArticles } from '@/apis/article';

export default {
  name: 'Home',
  components: {
    XContainer,
    ProductHome,
    // Product,
    // Article,
    ArticleBorderless,
    // IconSet,
    // VuePerfectScrollbar,
    // SmallSellerSection,
    // Reader,
    // ShadowDivider,
    // StandardSection,
    OrderFloatIcon,
    StandardProductSection,
  },
  data() {
    return {
      carousels: [
        { url: 'https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-15_cHs__qHEb_V.jpg', id: 17 },
        { url: 'https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-44_T8vQlK2x7.png', id: 9 },
      ],
      articles: [],
      products: [],
      currPage: 1,
      pageSize: 5,
    };
  },
  computed: mapState({
    company: state => state.company,
  }),
  async mounted() {
    const loading = this.$buefy.loading.open();
    try {
      const [products] = await Promise.all([
        getFeaturedProducts(),
        // getArticles(this.currPage, this.pageSize),
      ]);
      const { articles } = await getArticles(this.currPage, this.pageSize);
      this.products = products;
      this.articles = articles;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      loading.close();
    }
  },
  methods: {
    goToProductList() {
      this.$router.push({
        name: 'ProductList',
      });
    },
    goToProductDetail(id) {
      this.$router.push({
        name: 'ProductDetail',
        params: {
          id,
        },
      });
    },
    gotoArticlePage(id) {
      this.$router.push({
        name: 'ArticleDetail',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-article-list-view-vertical-articel-minimize{
  height: 30%;
}
.section-six{
   background-image:url("https://ik.imagekit.io/osusf6xvdf/beta/home-mobile-2_KN39uw8IK4GD.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    &-test{
      height:100%;
      padding-top: 100%;
    }
}
.move-right-position div{
  right: 80px;
}
@media screen and (min-width: 700px) {
   .carousel-arrow{
     display: none !important;
   }
}
.md-button-bg{
  padding: 5px 30px 5px 30px;
  background: url("../../../src/assets/img/home/button-menu-active.png");
  background-position: center;
}
.cursor{
  cursor: pointer;
}
.carousel-indicator {
  bottom: 200px  !important;
}
.section{

  &-one{
     position: relative;
     z-index: 2;
     margin-top:-10%;
    &-bg{
    }
    &-leave{
      z-index: 999;
      width: 30%;
      position: absolute;
      top:-10rem;
      right: 0rem;
    }
  }

  &-two{
    position: relative;
    z-index: 2;
    @media screen and (max-width: 768px) {
      z-index: 3 !important;
      margin-top: -100%;
    }
    &-bg{
      position: absolute;
      z-index: -1;
      margin-top: -15%;
      left:0%;
    }
  }
  &-four{
     position: relative;
     z-index: 3;
     &-bg{
      position: absolute;
      z-index:-1;
      margin-top: -15%;
      left:0%;
    }
    &-title{
      font-size:2rem;
      font-weight: 800;
      margin-bottom: 30px;
    }
    }
  &-three{
    position: relative;
    z-index: 3;
    &-content{
      position: absolute;
      margin-top:-75%;
      &-content{
        padding-right: 40px;
        padding-left: 40px;
      }
    }
  }
  &-five{
     position: relative;
     z-index: 2;
    //  padding-top: 30%;
  }
}

.md-text-title{
  font-size:2rem;
  font-weight: 800;
}
.text-center{
  text-align: center;
}
.home-section-bg-2{
  background: url("../../../src/assets/img/home/section-bg-1.png");
}
.home-section-bg-1{
   background: url("../../../src/assets/img/home/section-bg-1.png");
   padding-top: 2rem;
   padding-bottom: 700px;
   background-size: contain;
   background-repeat: no-repeat;
}
.cp-home {
  position: relative;
  text-align: center;
}

.cp-home-shadow-divider {
  position: relative;
  top: -40px;
  z-index: -1;
  width: 80%;
  margin-right: auto;
  margin-left: auto;
}

.cp-home-picture {
  width: 100%;
}

.cp-home-logo {
  margin-top: 40px;
  margin-bottom: 15px;
  height: 50px;

  @media screen and (max-width: 768px) {
    height: 20px;
  }
}

.cp-home-sample-about {
  width: 70%;
  overflow: hidden;
  max-height: 150px;
  box-shadow: inset 0px -10px 10px -10px #cacaca;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}

.cp-home-icon-set {
  margin-top: 40px;
}

.cp-home-product-section {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;

  &-label {
    margin-left: auto;
    margin-right: auto;
    width: 200px;
    border-radius: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;

    @media screen and (max-width: 768px) {
      padding-top: 20px;
      padding-bottom: 20px;
      width: 100%;
      border-radius: 0;
    }
  }

  &-list {
    display: flex;
    padding-left: 10%;
    padding-right: 10%;
    align-items: flex-start;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

.cp-home-article-section {
  background-color: white;
  width: 90%;
  margin-left: auto;
  margin-right: auto;

  &-title {
    margin-top: 1.5rem;
    margin-bottom: 1.2rem;
  }

  &-list {
    padding-left: 20px;
    margin-bottom: 1.5rem;
    position: relative;
    width: 100%;
    height: 380px;
  }

  &-list-container {
    margin-left: auto;
    margin-right: auto;
    width: max-content;
  }
}
</style>
